import React from "react";
import { LazyImg } from "arv-reactcomponents";
import { Anchor, ProductList, Methods } from "arv-extends";
import { pageType } from "arv-extends/constants";
import LazyLoad from 'react-lazyload';

const { ProductBtns, PriceBlock, ProductPromotions, ColorsAvail } = ProductList;
const { getBackgroundColorCode } = Methods;
const { wrapper, getFinalComponent } = ProductList.ProductView;

class ProductViewComponet extends wrapper {
  static imageStyleObj() {
    return {
      backgroundColor: getBackgroundColorCode(),
    };
  }

  static historyState(link) {
    return {
      pathname: link,
      state: {
        currentPage: pageType.pdp,
      },
    };
  }

  static linkTarget(isDesktop) {
    return isDesktop ? "_blank" : "_self";
  }

  get onsaleClassName() {
    return (!this.props.promotions.length > 0 && "nwc-hide") || "";
  }

  render() {
    const {
      index,
      currentIndex,
      altImage,
      link,
      brandText,
      productTitle,
      discountRange,
      mrpRange,
      isNew,
      sellingPriceRange,
      promotions,
      isAllPromotions,
      styleId,
      moreColors,
      onWinLoad,
      inStock,
    } = this.props;
    const { isDesktop } = this.props.CommonStore;
    return (
      <Anchor.component
        href={link}
        to={ProductViewComponet.historyState(link)}
        className="nw-productview"
        target={ProductViewComponet.linkTarget(isDesktop)}
        onClick={this.onProductClick}
      >
        <div className="nwc-hide">{link}</div>
        <div className="nwc-hide">{this.productMainImage}</div>
        <div className="nw-productview-imgcontainer">
          {!inStock && (
            <div className="nw-productview-outofstock">
              OUT OF STOCK
            </div>
          ) || null}
          <div className="nw-productview-imgwrapper">
            <div
              className={`nw-productview-imgbgblk ${this.hiddenPlaceholderClassName}`}
              style={ProductViewComponet.imageStyleObj()}
            />
            {(isDesktop && (
              <LazyLoad>
                <LazyImg
                  index={currentIndex}
                  src={altImage}
                  className="nw-productview-img nw-productview-imgalt"
                  rootMargin="1500px"
                  onError={this.onAltImgError}
                  alt={this.imageAlt}
                />
              </LazyLoad>
            )) ||
              null}
            <LazyLoad>
              <LazyImg
                index={currentIndex}
                src={this.productMainImage}
                className={`nw-productview-img nw-productview-imgmain ${
                  this.isSingleImageClassName
                  }`}
                rootMargin="1500px"
                onLoad={this.onMainImgLoad}
                onError={this.onMainImgError}
                onWinLoad={onWinLoad}
                alt={this.imageAlt}
              />
            </LazyLoad>
            <div
              className={`
              wc-productview-salewrap
              ${this.onsaleClassName}
            `}
            >
              {" "}
              On Sale
            </div>
            <div
              className={`
              wc-productview-newwrap
              ${this.isNewClassName}
            `}
            >
              {" "}
              New
            </div>
          </div>
          <ProductBtns.component
            index={index}
            promotions={promotions}
            isAllPromotions={isAllPromotions}
            mainImage={this.productMainImage}
            brandText={brandText}
            productTitle={productTitle}
            discountRange={discountRange}
            styleId={styleId}
            isNew={isNew}
            mrpRange={mrpRange}
            sellingPriceRange={sellingPriceRange}
          />
        </div>
        <div className="nw-productview-info">
          <div className="nw-productview-producttitle">{productTitle}</div>
          <PriceBlock.component
            className="nw-productview-priceblk"
            discountRange={discountRange}
            mrpRange={mrpRange}
            sellingPriceRange={sellingPriceRange}
            bottomCarousel={true}
          />
          <ProductPromotions.component promotions={promotions} />
          <ColorsAvail.component moreColors={moreColors} />
        </div>
      </Anchor.component>
    );
  }
}

ProductList.ProductView.component = getFinalComponent(ProductViewComponet);
